import { CompanyConfigForm } from '../company-config.interface'

export const getCompanyConfigInitialValues = (form?: CompanyConfigForm): CompanyConfigForm => {
  if (form) {
    return {
      name: form.name,
      projects: form.projects,
      departments: form.departments,
      employees: form.employees,
    }
  }

  return {
    name: '',
    projects: undefined,
    departments: undefined,
    employees: undefined,
  }
}
